import { useMutation, useQuery } from '@tanstack/react-query';
import { request } from 'utils/request';

export const getListSystemNotification = params => request.get('/api/v1/notification/list', { params });
export const createSystemNotificationSetting = data => request.post('/api/v1/notification', data);
export const updateSystemNotificationSetting = data => request.post('api/v1/notification/update', data);
export const deleteSystemNotificationSetting = data => request.post('/api/v1/users/notification/delete', data);
// Mutation
export const useCreateSystemNotificationSetting = () => useMutation({ mutationFn: createSystemNotificationSetting });
export const useUpdateSystemNotificationSetting = () => useMutation({ mutationFn: updateSystemNotificationSetting });
export const useDeleteSystemNotificationSetting = () => useMutation({ mutationFn: deleteSystemNotificationSetting });
// Query
export const useQueryGetSystemNotification = (params = {}, options = {}) =>
  useQuery({ queryKey: ['GET_SYSTEM_NOTIFICATION', params], queryFn: () => getListSystemNotification(params), ...options });
